import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Página pública (sin auth) para que un destinatario en Cc pueda hacer opt-out
 * con un click. Se llega desde los emails con ?ticket_id=...&scope=ticket|all
 * El usuario solo introduce su email y el backend genera el token correcto.
 */
export default function Unsubscribe() {
    const [params] = useSearchParams();
    const scope = params.get("scope") || "ticket";
    const ticketId = params.get("ticket_id") || "";
    const presetEmail = params.get("email") || "";

    const [email, setEmail] = useState(presetEmail);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [done, setDone] = useState(false);

    useEffect(() => { document.title = "Cancelar notificaciones · itotal4u"; }, []);

    const submit = async (e) => {
        e.preventDefault();
        if (!email || !email.includes("@")) {
            setError("Ingresa un correo válido");
            return;
        }
        setLoading(true); setError("");
        try {
            // Pide token al backend con el email del usuario
            const { data } = await axios.get(`${API}/email/unsubscribe/token`, {
                params: { email, scope, ticket_id: ticketId },
            });
            await axios.post(`${API}/email/unsubscribe`, {
                email,
                scope,
                ticket_id: ticketId,
                token: data.token,
            });
            setDone(true);
        } catch (err) {
            setError(err?.response?.data?.detail || "No se pudo procesar la cancelación. Intenta de nuevo.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="unsubscribe-page" style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#0F0F10", padding: 24 }}>
            <div style={{ maxWidth: 480, width: "100%", background: "#17171A", border: "1px solid #26262B", borderRadius: 12, padding: 28 }}>
                <div style={{ marginBottom: 18 }}>
                    <h1 style={{ margin: 0, color: "#fff", fontSize: 22, fontWeight: 700 }}>
                        {scope === "all" ? "🚫 No recibir ninguna notificación" : "🔕 No recibir notificaciones de este ticket"}
                    </h1>
                    <p style={{ color: "#A3A3A8", fontSize: 13.5, lineHeight: 1.6, margin: "10px 0 0" }}>
                        {scope === "all"
                            ? "Confirmamos tu correo y dejamos de copiarte en TODAS las notificaciones de tickets de soporte (sin importar el ticket)."
                            : <>Confirmamos tu correo y dejamos de copiarte en el ticket <b style={{ color: "#fff" }}>{ticketId || "—"}</b>.</>}
                    </p>
                </div>

                {done ? (
                    <div data-testid="unsubscribe-success" style={{ background: "#0d3a1d", border: "1px solid #16A34A", borderRadius: 8, padding: 16, color: "#86EFAC" }}>
                        <div style={{ fontWeight: 700, fontSize: 15, color: "#fff", marginBottom: 6 }}>✓ Cancelación registrada</div>
                        <div style={{ fontSize: 13, lineHeight: 1.5 }}>
                            {scope === "all"
                                ? <>El correo <b>{email}</b> dejará de recibir notificaciones de tickets de soporte. Puedes cerrar esta ventana.</>
                                : <>El correo <b>{email}</b> dejará de recibir notificaciones del ticket <b>{ticketId}</b>. Puedes cerrar esta ventana.</>}
                        </div>
                    </div>
                ) : (
                    <form onSubmit={submit} data-testid="unsubscribe-form">
                        <div className="field">
                            <label style={{ color: "#A3A3A8", fontSize: 12, textTransform: "uppercase", letterSpacing: ".06em" }}>Tu correo electrónico</label>
                            <input
                                type="email"
                                className="input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="tu@empresa.com"
                                autoFocus
                                required
                                data-testid="unsubscribe-email"
                                style={{ marginTop: 6, background: "#0F0F10", color: "#fff", border: "1px solid #404048", borderRadius: 6, padding: "10px 12px", width: "100%", fontSize: 14 }}
                            />
                        </div>
                        {error && <div data-testid="unsubscribe-error" style={{ color: "#FCA5A5", fontSize: 13, marginTop: 10 }}>{error}</div>}
                        <button
                            type="submit"
                            disabled={loading}
                            data-testid="unsubscribe-submit"
                            style={{ marginTop: 18, width: "100%", background: "#DC2626", color: "#fff", border: 0, borderRadius: 8, padding: "12px 16px", fontWeight: 600, fontSize: 14, cursor: loading ? "wait" : "pointer", opacity: loading ? 0.7 : 1 }}
                        >
                            {loading ? "Procesando…" : "Cancelar notificaciones"}
                        </button>
                    </form>
                )}

                <p style={{ marginTop: 24, paddingTop: 18, borderTop: "1px solid #26262B", color: "#737373", fontSize: 11.5, textAlign: "center" }}>
                    itotal4u · Soporte · <a href="/login" style={{ color: "#A3A3A8" }}>Iniciar sesión</a>
                </p>
            </div>
        </div>
    );
}
